// src/components/messaging/MessageInput.tsx
import React, { useState, useRef } from 'react';

interface MessageInputProps {
  onSendMessage: (content: string) => void;
  onTyping: (content: string) => void;
  disabled?: boolean;
}

const MessageInput: React.FC<MessageInputProps> = ({ 
  onSendMessage, 
  onTyping, 
  disabled = false 
}) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message);
      setMessage('');
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setMessage(value);
    onTyping(value);
    
    // Auto-resize textarea
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 120)}px`;
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-end space-x-2">
      <div className="flex-1 relative">
        <textarea
          ref={textareaRef}
          value={message}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          placeholder={disabled ? "Connecting..." : "Type a message..."}
          disabled={disabled}
          className="w-full bg-white text-coffee border-2 border-coffee rounded-xl px-4 py-2 placeholder-coffee/40 focus:outline-none focus:border-terracotta focus:ring-1 focus:ring-terracotta resize-none min-h-[40px] max-h-[120px]"
          rows={1}
        />
      </div>
      
      <button
        type="submit"
        disabled={!message.trim() || disabled}
        className="bg-terracotta text-white border-2 border-coffee rounded-lg font-bold hover:bg-[#d89050] transition-colors disabled:opacity-50 disabled:cursor-not-allowed px-4 py-2"
      >
        Send
      </button>
    </form>
  );
};

export default MessageInput;